import React, { useEffect, useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LinkIcon, PaintbrushIcon, MessageSquareIcon, SmartphoneIcon, SendIcon, ShieldIcon, DollarSignIcon, TimerIcon, EyeIcon, MessageCircleIcon, MessageSquareWarningIcon } from 'lucide-react';
import { isMobile } from '../utils/deviceDetection';
export const ClientExperience = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [autoAdvanceTimer, setAutoAdvanceTimer] = useState(null);
  const documentSteps = [{
    id: 'photo-id',
    title: 'Photo ID',
    type: 'Upload',
    content: <motion.div className="w-full rounded-xl border-2 border-dashed border-[#E7EAF0] bg-white/50 flex flex-col items-center justify-center transition-colors duration-300 py-8 px-4" whileHover={{
      borderColor: '#2E6BFF',
      backgroundColor: '#F0F5FF',
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-102">
          <motion.div className="p-4 rounded-full bg-[#F0F5FF] text-[#2E6BFF] mb-3" data-id="element-103">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-104">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-id="element-105" />
              <polyline points="17 8 12 3 7 8" data-id="element-106" />
              <line x1="12" y1="3" x2="12" y2="15" data-id="element-107" />
            </svg>
          </motion.div>
          <p className="text-[#0B1220] font-medium mb-1 text-center" data-id="element-108">
            Drag files here or click to upload
          </p>
          <p className="text-[#5A6376] text-xs text-center" data-id="element-109">
            Any file type. No size restrictions.
          </p>
          <motion.button className="mt-6 px-4 py-2 bg-[#2E6BFF] text-white rounded-full text-sm font-medium" whileHover={{
        scale: 1.05,
        boxShadow: '0 4px 12px rgba(46,107,255,0.25)'
      }} whileTap={{
        scale: 0.95
      }} data-id="element-110">
            Browse Files
          </motion.button>
        </motion.div>
  }, {
    id: 'service-agreement',
    title: 'Service Agreement',
    type: 'Sign',
    content: <motion.div className="w-full rounded-xl border-2 border-[#E7EAF0] bg-white/50 flex flex-col items-center justify-center transition-colors duration-300 py-8 px-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-111">
          <motion.div className="p-4 rounded-full bg-[#F0F5FF] text-[#2E6BFF] mb-3" data-id="element-112">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-113">
              <path d="M12 20h9" data-id="element-114"></path>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" data-id="element-115"></path>
            </svg>
          </motion.div>
          <p className="text-[#0B1220] font-medium mb-1 text-center" data-id="element-116">
            Review and sign the service agreement
          </p>
          <p className="text-[#5A6376] text-xs text-center mb-6" data-id="element-117">
            Electronic signature required
          </p>
          <motion.button className="px-4 py-2 bg-[#2E6BFF] text-white rounded-full text-sm font-medium flex items-center" whileHover={{
        scale: 1.05,
        boxShadow: '0 4px 12px rgba(46,107,255,0.25)'
      }} whileTap={{
        scale: 0.95
      }} data-id="element-118">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-119">
              <path d="M12 20h9" data-id="element-120"></path>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" data-id="element-121"></path>
            </svg>
            Sign Now
          </motion.button>
        </motion.div>
  }, {
    id: 'intake-form',
    title: 'Intake Form',
    type: 'Complete',
    content: <motion.div className="w-full rounded-xl border-2 border-[#E7EAF0] bg-white/50 flex flex-col items-center justify-center transition-colors duration-300 py-8 px-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-122">
          <motion.div className="p-4 rounded-full bg-[#F0F5FF] text-[#2E6BFF] mb-3" data-id="element-123">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-124">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" data-id="element-125"></path>
              <polyline points="14 2 14 8 20 8" data-id="element-126"></polyline>
              <line x1="16" y1="13" x2="8" y2="13" data-id="element-127"></line>
              <line x1="16" y1="17" x2="8" y2="17" data-id="element-128"></line>
              <polyline points="10 9 9 9 8 9" data-id="element-129"></polyline>
            </svg>
          </motion.div>
          <p className="text-[#0B1220] font-medium mb-1 text-center" data-id="element-130">
            Fill out the required intake form
          </p>
          <p className="text-[#5A6376] text-xs text-center mb-6" data-id="element-131">
            Complete the PDF form online or download
          </p>
          <motion.button className="px-4 py-2 bg-[#2E6BFF] text-white rounded-full text-sm font-medium flex items-center" whileHover={{
        scale: 1.05,
        boxShadow: '0 4px 12px rgba(46,107,255,0.25)'
      }} whileTap={{
        scale: 0.95
      }} data-id="element-132">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-133">
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" data-id="element-134"></path>
              <path d="m9 12 2 2 4-4" data-id="element-135"></path>
            </svg>
            Fill Online
          </motion.button>
        </motion.div>
  }, {
    id: 'ssn',
    title: 'Social Security Number',
    type: 'Enter',
    content: <motion.div className="w-full rounded-xl border-2 border-[#E7EAF0] bg-white/50 flex flex-col items-center justify-center transition-colors duration-300 py-8 px-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-136">
          <motion.div className="p-4 rounded-full bg-[#F0F5FF] text-[#2E6BFF] mb-3" data-id="element-137">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-138">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-139"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-140"></path>
            </svg>
          </motion.div>
          <div className="text-center mb-1" data-id="element-141">
            <p className="text-[#0B1220] font-medium mb-0.5" data-id="element-142">
              Enter your Social Security Number
            </p>
          </div>
          <div className="w-full max-w-xs mb-2" data-id="element-143">
            <div className="relative" data-id="element-144">
              <input type="text" placeholder="XXX-XX-XXXX" className="w-full px-4 pr-24 py-2 border border-[#E7EAF0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2E6BFF]/20 focus:border-[#2E6BFF]" data-id="element-145" />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-146">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 mr-1 text-[#5A6376]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-147">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-148"></path>
                </svg>
                <span className="text-[#5A6376] text-xs" data-id="element-149">Encrypted</span>
              </div>
            </div>
          </div>
          <motion.button className="px-4 py-2 bg-[#2E6BFF] text-white rounded-full text-sm font-medium" whileHover={{
        scale: 1.05,
        boxShadow: '0 4px 12px rgba(46,107,255,0.25)'
      }} whileTap={{
        scale: 0.95
      }} data-id="element-150">
            Submit
          </motion.button>
        </motion.div>
  }];
  useEffect(() => {
    const timer = setTimeout(() => {
      setActiveStep(prev => (prev + 1) % documentSteps.length);
    }, isMobile() ? 8000 : 5000);
    setAutoAdvanceTimer(timer);
    return () => clearTimeout(timer);
  }, [activeStep, documentSteps.length]);
  const handleStepChange = index => {
    if (autoAdvanceTimer) {
      clearTimeout(autoAdvanceTimer);
    }
    setActiveStep(index);
  };
  const features = [{
    title: 'No Account Required',
    description: 'Clients access via secure links - no passwords to remember.',
    icon: <LinkIcon className="h-6 w-6" data-id="element-151" />
  }, {
    title: 'Branded Upload Portal',
    description: 'Customize the client experience with your brand colors and logo.',
    icon: <PaintbrushIcon className="h-6 w-6" data-id="element-152" />
  }, {
    title: 'Request Changes Workflow',
    description: 'Easily request document revisions with clear instructions.',
    icon: <MessageSquareWarningIcon className="h-6 w-6" data-id="element-153" />
  }, {
    title: 'Mobile-Friendly Design',
    description: 'Perfect experience on any device - desktop, tablet, or phone.',
    icon: <SmartphoneIcon className="h-6 w-6" data-id="element-154" />
  }, {
    title: 'Multi-Channel Delivery',
    description: 'Send requests via email, SMS, or your preferred communication method.',
    icon: <MessageCircleIcon className="h-6 w-6" data-id="element-155" />
  }, {
    title: 'Secure File Sharing',
    description: 'Send files with open tracking, expiration dates, and payment gates.',
    icon: <SendIcon className="h-6 w-6" data-id="element-156" />
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: isMobile() ? 0.05 : 0.1,
        delayChildren: isMobile() ? 0.1 : 0.3
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: isMobile() ? 10 : 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: isMobile() ? 'tween' : 'spring',
        stiffness: isMobile() ? 50 : 100,
        duration: isMobile() ? 0.3 : undefined
      }
    }
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-[#F8FAFF] relative overflow-hidden" data-id="element-157">
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-158">
        {!isMobile() ? <>
            <motion.div className="absolute top-0 right-0 w-[50%] h-[50%] rounded-full bg-gradient-to-b from-[#E7FFF7]/30 to-transparent blur-[80px]" animate={{
          x: [0, 20, 0],
          y: [0, -20, 0]
        }} transition={{
          duration: 15,
          repeat: Infinity,
          repeatType: 'reverse',
          ease: 'easeInOut'
        }} data-id="element-159" />
            <motion.div className="absolute bottom-0 left-0 w-[40%] h-[40%] rounded-full bg-gradient-to-t from-[#F0F5FF]/40 to-transparent blur-[60px]" animate={{
          x: [0, -20, 0],
          y: [0, 20, 0]
        }} transition={{
          duration: 18,
          repeat: Infinity,
          repeatType: 'reverse',
          ease: 'easeInOut',
          delay: 1
        }} data-id="element-160" />
          </> : <>
            <div className="absolute top-0 right-0 w-[50%] h-[50%] rounded-full bg-gradient-to-b from-[#E7FFF7]/30 to-transparent blur-[80px]" data-id="element-161" />
            <div className="absolute bottom-0 left-0 w-[40%] h-[40%] rounded-full bg-gradient-to-t from-[#F0F5FF]/40 to-transparent blur-[60px]" data-id="element-162" />
          </>}
      </div>
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-164">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B1220] bg-gradient-to-r from-[#0B1220] to-[#0BB489] bg-clip-text text-transparent" data-id="element-165">
            Seamless Client Experience
          </h2>
          <p className="mt-4 text-lg text-[#5A6376] max-w-2xl mx-auto" data-id="element-166">
            Make document submission effortless for your clients with our
            intuitive interface.
          </p>
        </motion.div>
        <div className="mb-16" data-id="element-167">
          <motion.div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg border border-white/50 overflow-hidden flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5
        }} whileHover={{
          y: -5,
          boxShadow: '0 20px 40px rgba(9,16,29,0.1)'
        }} data-id="element-168">
            <div className="p-6 flex flex-col h-full" data-id="element-169">
              <div className="flex flex-col items-center" data-id="element-170">
                <div className="flex items-center justify-center mb-2" data-id="element-171">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hWC68PB9TZa4eAbjU5F6TT/ACME_Logo.png" alt="ACME Logo" className="h-8 mr-2 my-auto" data-id="element-172" />
                  <h3 className="text-xl font-semibold text-[#0B1220] my-auto" data-id="element-173">
                    Upload Portal
                  </h3>
                </div>
                <p className="text-[#5A6376] mb-6" data-id="element-174">
                  John Smith - Reference #: DOC-2023-05789
                </p>
              </div>
              <div className="flex flex-col md:flex-row h-full" data-id="element-175">
                {/* Left side: Vertical checklist */}
                <div className="w-full md:w-1/3 md:pr-6 md:border-r border-[#E7EAF0] flex flex-col mb-6 md:mb-0" data-id="element-176">
                  {documentSteps.map((step, index) => <motion.button key={step.id} className={`text-left p-4 mb-2 rounded-lg transition-all relative ${activeStep === index ? 'bg-[#F0F5FF] text-[#2E6BFF]' : 'hover:bg-gray-50 text-[#5A6376]'}`} onClick={() => handleStepChange(index)} whileHover={{
                  x: activeStep === index ? 0 : 2
                }} whileTap={{
                  scale: 0.98
                }} data-id="element-177">
                      <div className="flex items-center" data-id="element-178">
                        <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-3 ${activeStep === index ? 'bg-[#2E6BFF] text-white' : 'bg-[#E7EAF0] text-[#5A6376]'}`} data-id="element-179">
                          {index + 1}
                        </div>
                        <div className="flex flex-col" data-id="element-180">
                          <span className="font-medium" data-id="element-181">{step.title}</span>
                          <div className="mt-1" data-id="element-182">
                            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${step.type === 'Upload' ? 'bg-blue-50 text-blue-500' : step.type === 'Sign' ? 'bg-purple-50 text-purple-500' : step.type === 'Complete' ? 'bg-emerald-50 text-emerald-500' : 'bg-amber-50 text-amber-500'}`} data-id="element-183">
                              {step.type === 'Upload' && <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-184">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" data-id="element-185" />
                                </svg>}
                              {step.type === 'Sign' && <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-186">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" data-id="element-187" />
                                </svg>}
                              {step.type === 'Complete' && <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-188">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-189" />
                                </svg>}
                              {step.type === 'Enter' && <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-190">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-191" />
                                </svg>}
                              {step.type === 'Upload' && 'File Upload'}
                              {step.type === 'Sign' && 'E-Signature'}
                              {step.type === 'Complete' && 'Fillable Form'}
                              {step.type === 'Enter' && 'Text Input'}
                            </span>
                          </div>
                        </div>
                      </div>
                      {activeStep === index && <motion.div className="absolute left-0 top-0 bottom-0 w-1 bg-[#2E6BFF] rounded-r-full" layoutId="activeIndicator" initial={{
                    opacity: 0
                  }} animate={{
                    opacity: 1
                  }} exit={{
                    opacity: 0
                  }} transition={{
                    duration: 0.2
                  }} data-id="element-192" />}
                    </motion.button>)}
                </div>
                {/* Right side: Content for the selected checklist item */}
                <div className="w-full md:w-2/3 md:pl-6" data-id="element-193">
                  <AnimatePresence mode="wait" data-id="element-194">
                    <motion.div key={documentSteps[activeStep].id} initial={{
                    opacity: 0,
                    x: 20
                  }} animate={{
                    opacity: 1,
                    x: 0
                  }} exit={{
                    opacity: 0,
                    x: -20
                  }} transition={{
                    duration: 0.3
                  }} className="h-full flex items-center justify-center" data-id="element-195">
                      {documentSteps[activeStep].content}
                    </motion.div>
                  </AnimatePresence>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
        <motion.div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: isMobile() ? '-50px' : '-100px'
      }} data-id="element-196">
          {features.map((feature, index) => <motion.div key={index} variants={item} className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-6 border border-white/50 hover:shadow-xl transition-all duration-300" whileHover={isMobile() ? {} : {
          y: -5,
          boxShadow: '0 20px 40px rgba(9,16,29,0.1)',
          backgroundColor: 'rgba(255, 255, 255, 0.9)'
        }} data-id="element-197">
              <div className="bg-gradient-to-br from-[#E7FFF7] to-[#D0F8EB] w-12 h-12 rounded-full flex items-center justify-center mb-4 text-[#0BB489] shadow-[0_4px_10px_rgba(11,180,137,0.15)]" data-id="element-198">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-[#0B1220] mb-2" data-id="element-199">
                {feature.title}
              </h3>
              <p className="text-[#5A6376]" data-id="element-200">{feature.description}</p>
              {feature.title === 'Secure File Sharing'}
            </motion.div>)}
        </motion.div>
        <motion.div className="mt-16 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.5
      }} data-id="element-201">
          <motion.a href="https://calendly.com/pigeondocuments" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full text-white bg-gradient-to-r from-[#0BB489] to-[#36D1DC] hover:from-[#0AA27D] hover:to-[#32C3CE] shadow-[0_8px_16px_rgba(11,180,137,0.25)] transition-all duration-300" whileHover={{
          y: -2,
          boxShadow: '0 12px 20px rgba(11,180,137,0.3)'
        }} whileTap={{
          scale: 0.98
        }} data-id="element-202">
            Book a Call
          </motion.a>
        </motion.div>
      </div>
    </section>;
};